module.exports = __webpack_public_path__ + "assets/img/help_mima2.29d3e700.png";